var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "交班对账（F12）",
        maskClosable: false,
        width: "860px",
        okText: "打印",
        cancelText: "关闭",
      },
      on: {
        ok: _vm.print,
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "shift-toolbar" },
        [
          _c("span", [_vm._v("时段：")]),
          _c("a-date-picker", {
            staticStyle: { width: "140px" },
            attrs: { format: "YYYY-MM-DD" },
            model: {
              value: _vm.beginDate,
              callback: function ($$v) {
                _vm.beginDate = $$v
              },
              expression: "beginDate",
            },
          }),
          _c("span", [_vm._v("至")]),
          _c("a-date-picker", {
            staticStyle: { width: "140px" },
            attrs: { format: "YYYY-MM-DD" },
            model: {
              value: _vm.endDate,
              callback: function ($$v) {
                _vm.endDate = $$v
              },
              expression: "endDate",
            },
          }),
          _c(
            "a-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.load },
            },
            [_vm._v("查询")]
          ),
          _c("span", { staticClass: "shift-tip" }, [
            _vm._v("默认今日 00:00 ~ 现在"),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { ref: "printArea", staticClass: "shift-report" },
        [
          _c("div", { staticClass: "report-title" }, [
            _vm._v("交班对账单（" + _vm._s(_vm.cashierName) + "）"),
          ]),
          _c("div", { staticClass: "report-range" }, [
            _vm._v(
              _vm._s(_vm.report.beginTime || "") +
                " ~ " +
                _vm._s(_vm.report.endTime || "")
            ),
          ]),
          _c("div", { staticClass: "sum-cards" }, [
            _c("div", { staticClass: "sum-card" }, [
              _c("div", { staticClass: "sum-num" }, [
                _vm._v(_vm._s(_vm.report.salesCount || 0)),
              ]),
              _c("div", { staticClass: "sum-label" }, [_vm._v("销售单数")]),
            ]),
            _c("div", { staticClass: "sum-card" }, [
              _c("div", { staticClass: "sum-num" }, [
                _vm._v("¥" + _vm._s(_vm.format(_vm.report.salesTotal))),
              ]),
              _c("div", { staticClass: "sum-label" }, [_vm._v("销售金额")]),
            ]),
            _c("div", { staticClass: "sum-card" }, [
              _c("div", { staticClass: "sum-num" }, [
                _vm._v(_vm._s(_vm.report.returnCount || 0)),
              ]),
              _c("div", { staticClass: "sum-label" }, [_vm._v("退货单数")]),
            ]),
            _c("div", { staticClass: "sum-card" }, [
              _c("div", { staticClass: "sum-num" }, [
                _vm._v("¥" + _vm._s(_vm.format(_vm.report.returnTotal))),
              ]),
              _c("div", { staticClass: "sum-label" }, [_vm._v("退货金额")]),
            ]),
            _c("div", { staticClass: "sum-card main" }, [
              _c("div", { staticClass: "sum-num" }, [
                _vm._v("¥" + _vm._s(_vm.format(_vm.report.netTotal))),
              ]),
              _c("div", { staticClass: "sum-label" }, [_vm._v("实收净额")]),
            ]),
          ]),
          _c(
            "a-tabs",
            { attrs: { size: "small" } },
            [
              _c(
                "a-tab-pane",
                { key: "sales", attrs: { tab: "收款汇总" } },
                [
                  _c("a-table", {
                    attrs: {
                      columns: _vm.payColumns,
                      dataSource: _vm.report.sales || [],
                      pagination: false,
                      size: "small",
                      rowKey: "payType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-tab-pane",
                { key: "returns", attrs: { tab: "退款汇总" } },
                [
                  _c("a-table", {
                    attrs: {
                      columns: _vm.payColumns,
                      dataSource: _vm.report.returns || [],
                      pagination: false,
                      size: "small",
                      rowKey: "payType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-tab-pane",
                { key: "details", attrs: { tab: "流水明细" } },
                [
                  _c("a-table", {
                    attrs: {
                      columns: _vm.detailColumns,
                      dataSource: _vm.report.details || [],
                      pagination: false,
                      size: "small",
                      rowKey: "number",
                      scroll: { y: 300 },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }